import {
    FooterLink,
    FooterContainer,
    LinksContainer
} from '@components/footer-links/styles';
import { Grid } from '@material-ui/core';
import * as React from 'react';

interface LabelledURL {
    url: string;
    label: string;
}

interface Props {
    links: LabelledURL[];
}

const FooterLinks: React.FunctionComponent<Props> = ({ links }) => {
    return (
        <FooterContainer container={true}>
            <LinksContainer xs={12}
                            item={true}
                            container={true}>
                {
                    links.map(({ url, label }, index) => (
                        <Grid container={true}
                              item={true}
                              direction='row'
                              justifyContent='center'
                              alignItems='stretch'
                              xs={true}
                              key={`${label}_${index}`}>
                            <FooterLink target='_blank' href={url}>{label}</FooterLink>
                        </Grid>
                    ))
                }
            </LinksContainer>
        </FooterContainer>
    );
};

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/components/footer-links/index.tsx